export function toQueryString(query): string {
  const queryString = [];
  let value;
  const convertToQueryString = (key, v) => {
    queryString.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
  };

  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      value = query[key];
      if (Array.isArray(value)) {
        value.forEach((_value) => {
          convertToQueryString(key, _value);
        });
      } else {
        convertToQueryString(key, value);
      }
    }
  }
  return queryString.join('&');
}
